<template>
<v-container fluid px-0 py-0 fill-height style="position: fixed">

  <div class="text-xs-center">
    <v-dialog
      fullscreen hide-overlay transition="dialog-bottom-transition"
      v-model="imageDialog">
      <v-card style="overflow:auto">
        <v-btn icon @click="imageDialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <img :src="imageDialogFile">
      </v-card>
    </v-dialog>
  </div>

  <v-snackbar
    style="opacity: 0.95; z-index: 2001"
    color="grey darken-3"
    class="snackbar-info"
    :multi-line="true"
    :bottom="true"
    :left="true"
    :timeout="snackbarInfoTimeout"
    v-model="snackbarInfo">
    <div>
      <v-icon color="white">info</v-icon>
      &nbsp; {{ snackbarInfoText }}
    </div>
  </v-snackbar>

    <v-layout row wrap>
      <v-flex xs12 id="audit-controls">
        <v-container px-0 py-0>
          <v-layout row wrap>
            <v-flex xs6>
              <v-btn
                color="green darken-4 white--text"
                @click="initAddConditionConfirmLocation">
                <v-icon class="mr-2">pin_drop</v-icon>
                Add Condition
              </v-btn>
            </v-flex>
            <v-flex xs6 class="pt-1 text-xs-center" style="font-size: 1.1em">
              <strong>{{ conditionsRecorded }}</strong> conditions added
              <v-btn
                :disabled="!conditionsRecorded"
                @click="showConditionsList = !showConditionsList"
                icon>
                <v-icon>pageview</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs12 fill-height style="position: relative">
        <v-btn
          @click="panToMyGeoLocation"
          style="z-index:500; top:10px; right:10px;"
          color="white"
          fab
          small
          absolute
          top
          right>
          <v-icon>gps_fixed</v-icon>
        </v-btn>

        <div ref="map-popup">
          <div class="map-popup">
            <p>Is this the correct location of the condition? Please drag marker accordingly and then confirm.</p><br>
            <v-btn color="primary" @click="initAddConditionShowForm">Yes</v-btn>
            <v-btn @click="cancelAddCondition">Cancel</v-btn>
          </div>
        </div>

        <div id="audit-map"></div>

        <div id="audit-conditions" v-if="showConditionsList">

          <v-layout>
            <v-flex>
              <v-card flat>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">Conditions</h3>
                    <div>List of conditions that you have added</div>
                    <v-list two-line>
                      <template v-for="(item, index) in conditionsList">
                        <v-list-tile
                          :key="item.id"
                          avatar>
                          <v-list-tile-avatar>
                            <img 
                            v-if="item.photos.length"
                            style="border-radius:0"
                            @click="activateImageViewer(apiBaseUrl + '/uploads/' + item.photos[0].filename)"
                            :src="apiBaseUrl + '/uploads/thumbs/' + item.photos[0].filename">
                            <v-icon large v-else>insert_photo</v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ item.observation }} -
                              {{ item.location_type }}
                            </v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.description"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-list>
                  </div>
                </v-card-title>
                <v-card-actions>
                  <v-btn
                    flat
                    @click="showConditionsList = false"
                    color="grey">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>        
        </div>
      </v-flex>
    </v-layout>

  <!-- condition form dialog -->
  <condition-form
    ref="condition-form"
    :saveConditionMethod="conditionSaved"
    :confirmedLocation="confirmConditionLocation">
  </condition-form>

</v-container>
</template>

<script>
  // import clockTime from 'clock-time'
  // import StopWatch from 'timer-stopwatch'
  import * as L from 'leaflet'
  import { watchGeoLocation, findTotalDistanceFromLatLngs } from '../helpers/geo-utils'
  import { headingDistanceTo } from 'geolocation-utils'
  import ConditionForm from '../components/ConditionForm'

  const apiBaseUrl = (process.env.NODE_ENV === 'production')
                    ? 'https://api.warnerconnects-audit.org'
                    : 'http://localhost:3030'

  let map, markerGPScenter, markerGPSaccuracy, markerConfirmLocation, stopWatch, intervalLocationCheck
  let recordedLocations = [], recordedConditions = []

  export default {
    components: {
      ConditionForm
    },
    data () {
      return {
        recordingStatus: 'off', // on/pending/off
        milesRecorded: 0,
        apiBaseUrl,
        conditionsRecorded: 0,
        timeRecorded: '00:00',
        promptedAddCondition: false,
        confirmLocation: false,
        confirmConditionLocation: false,
        confirmFinishAudit: false,
        conditionsList: [],
        imageDialog: false,
        imageDialogFile: '',
        auditID: '',
        auditUUID: '',
        showConditionsList: false,
        snackbarInfo: false,
        snackbarInfoText: '',
        snackbarInfoTimeout: 5000,
        startLatLng: [34.176571, -118.604794],
        startZoom: 14,
        myGeoLocationResult: {},
        myGeolocationIconOptions: {
          color: '#ffffff', // strokeColor
          opacity: 0.9, // strokeOpacity
          weight: 1.5, // strokeWeight
          fillColor: '#0050FF',
          fillOpacity: 0.15
        }
      }
    },
    computed: {
      myGeoLocationValid () {
        if (this.myGeoLocationResult === undefined) {
          return false
        }
        if (!this.myGeoLocationResult.hasOwnProperty('position')) {
          return false
        }
        return true
      },
      apiCallsActive () {
        return this.$store.getters.apiCallsInActive
      }
    },
    watch: {
      myGeoLocationResult (obj) {
        console.log('WATCH myGeoLocationResult', obj);
        if (!obj.lat) {
          console.log('Failed to get Geo-Location!', obj.message);
          return
        }
        this.addMyGeoLocationMarkerToMap(obj)
      },
    },
    methods: {
      activateSnackbar (content = '') {
        this.snackbarInfo = false
        setTimeout(() => {
          this.snackbarInfo = true
          // this.snackbarInfoTimeout = 500
          this.snackbarInfoText = content
        }, 100)
      },
      activateImageViewer (file) {
        this.imageDialog = true
        this.imageDialogFile = file
      },
      initMap () {console.log("***TCL: initMap -> map", map)
        console.log("TCL: initMap -> map", map)
        if (map) {
          return
        }
        map = L.map('audit-map').setView(this.startLatLng, this.startZoom);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 18,
          attribution: 'Tiles courtesy of <a href="http://openstreetmap.se/" target="_blank">OpenStreetMap Sweden</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);
        map.on('zoomend ', () => this.addMyGeoLocationMarkerToMap())
        L.control.scale().addTo(map);
      },
      initGeolocation () {
        watchGeoLocation()
          .then(result => {
            console.log('**watchGeoLocation', result)
            this.myGeoLocationResult = result
          })
          .catch(err => {
            console.warn('**watchGeoLocation ERROR', err)
          })
      },
      panToMyGeoLocation () {
        console.log("panToMyGeoLocation()", "myGeoLocationResult", this.myGeoLocationValid, this.myGeoLocationResult, map.getCenter().lat)
        if (!this.myGeoLocationValid) {
          return
        }
        let ll = [this.myGeoLocationResult.lat, this.myGeoLocationResult.lng]
        let distAwayMeters = headingDistanceTo(
          { lat: this.myGeoLocationResult.lat, lon: this.myGeoLocationResult.lng },
          { lat: map.getCenter().lat, lon: map.getCenter().lng }
        )
        map.flyTo(ll, 17, { animate: (distAwayMeters.distance < 1000) })
      },
      addMyGeoLocationMarkerToMap () {
        console.log('*myGeoLocationResult');
        if (!this.myGeoLocationValid) {
          return
        }
        let ll = [this.myGeoLocationResult.position.lat, this.myGeoLocationResult.position.lng]
        let metersPerPixel = function (latitude, zoomLevel) {
          var earthCircumference = 40075017;
          var latitudeRadians = latitude * (Math.PI/180);
          return earthCircumference * Math.cos(latitudeRadians) / Math.pow(2, zoomLevel + 8);
        };
        let pixelRadius = this.myGeoLocationResult.accuracy / metersPerPixel(this.myGeoLocationResult.position.lat, map.getZoom())
        // Need to convert meters into pixels
        // https://stackoverflow.com/questions/30703212/how-to-convert-radius-in-metres-to-pixels-in-mapbox-leaflet?rq=1
        // https://stackoverflow.com/questions/27545098/leaflet-calculating-meters-per-pixel-at-zoom-level
        if (markerGPSaccuracy && markerGPScenter) {
          markerGPSaccuracy.remove()
          markerGPScenter.remove()
        }
        let accuracyCircleOptions = Object.assign({}, this.myGeolocationIconOptions, { radius:pixelRadius, weight: 0 })
        let centerCircleOptions = Object.assign({}, this.myGeolocationIconOptions, { radius:6, fillOpacity:0.9 })
        markerGPSaccuracy = L.circleMarker(ll, accuracyCircleOptions).addTo(map).bringToBack();
        markerGPScenter = L.circleMarker(ll, centerCircleOptions).addTo(map);
      },
      recordMyLocation () {
        if (!this.myGeoLocationValid) {
          return
        }
        let ll = [this.myGeoLocationResult.lat, this.myGeoLocationResult.lng]

        // add marker to map
        let circleOptions = {
          radius: 4,
          color: '#ffffff', // strokeColor
          weight: 0, // strokeWeight
          fillColor: '#000000',
          fillOpacity: 0.9,
          zIndex: 900
        }
        let circle = L.circleMarker(ll, circleOptions).addTo(map)
        recordedLocations.push({latLng: ll, accuracy: this.myGeoLocationResult.accuracy, marker: circle, timestamp: this.myGeoLocationResult.timestamp})

        // record this to localStorage in case of browser crash
        let localStore = recordedLocations.map(x => {return {latLng: x.latLng, accuracy: x.accuracy}})
        localStorage['audit-locations--' + this.$route.params.auditcode] = JSON.stringify(localStore)

        // add polyline to map
        if (recordedLocations.length > 1) {
          let latLngs = recordedLocations.map(x => x.latLng)
          recordedLocations[recordedLocations.length-1].polyline = L.polyline(latLngs, { color: circleOptions.fillColor }).addTo(map);
          this.recordedDistance = (findTotalDistanceFromLatLngs(latLngs) * this.METER_TO_MILES).toFixed(2)
        }
        console.log("recordedLocations", recordedLocations)
      },
      removeMyLocations () {
        recordedLocations.forEach((x,i) => {
          x.marker.remove()
          delete recordedLocations[i].marker
          if (x.polyline) {
            x.polyline.remove()
            delete recordedLocations[i].polyline
          }
        })
        recordedConditions.forEach((x,i) => {
          if (x.marker) {
            x.marker.remove()
            delete recordedConditions[i].marker
          }
        })
        recordedLocations = []
      },
      conditionSaved (response) {
        console.log('**conditionSaved', response);
        function setColor (obType) {
          if (obType === 'Idea') {
            return 'purple'
          } else if (obType === 'Barrier') {
            return 'red'
          } else if (obType === 'Strength') {
            return '#2277ff'          
          }        
        }        
        let imgHtml = ''
        if (response.photos) {
          response.photos = (response.photos.length) ? response.photos : [response.photos]
          response.photos
            .map(i => i.filename)
            .forEach(imgurl => {
              imgHtml += `<img src="/${imgurl}" title="/${imgurl}" style="border:solid 1px #999; min-width:100px;min-height:100px; max-width:100px;max-height:100px"> `
            })
        }
        let latLng = [parseFloat(response.lat), parseFloat(response.lng)]
        let marker = new L.CircleMarker(latLng, {
            radius: 6,
            fillColor: setColor(response.observation),
            weight: 0,
            opacity: 1,
            fillOpacity: 0.8,
            title: "test"
          })
          .addTo(map)
          .on("click", (e) => {
            let content = `<strong>${response.observation}</strong> - ${response.createdAt.substr(0,16).split("T").join(" ")}<br>${response.description}<br><br>`
            if (response.photos) {
              if (response.photos.length) {
                response.photos.forEach(p => {
                  content += `<img class="photo-thumb" src="${apiBaseUrl + '/uploads/thumbs/' + p.filename}" onclick="window.open('${apiBaseUrl + '/uploads/thumbs/' + p.filename}')">`
                })
              }
            }
            e.target.bindPopup(`<div style="min-width: 320px; min-height: 100px">${content}</div>`).openPopup()
          });                  
        recordedConditions.push({response, marker})
        this.conditionsRecorded = recordedConditions.length
        this.conditionsList = recordedConditions.map(c => {
                  return {
                    observation: c.response.observation,
                    location_type: c.response.location_type,
                    condition_type: c.response.condition_type,
                    description: c.response.description,
                    photos: c.response.photos || [],
                    createdAt: c.response.createdAt
                  }
                })
                
                
      },
      initAddConditionConfirmLocation () {
        if (!this.myGeoLocationValid) {
          return
        }
        if (markerConfirmLocation) {
          markerConfirmLocation.remove()
        }
        this.activateSnackbar('Drag the marker to the correct position (if necessary)')

        this.confirmConditionLocation = this.myGeoLocationResult.position //[this.myGeoLocationResult.position.lat, this.myGeoLocationResult.position.lng]
        markerConfirmLocation = L.marker(this.myGeoLocationResult.position, { draggable: true, icon2: this.getConditionIcon() })
          .addTo(map)
          .bindPopup(this.$refs['map-popup']).openPopup();
        markerConfirmLocation.on('dragend', (e) => {
          this.confirmConditionLocation = e.target.getLatLng()
          markerConfirmLocation.bindPopup(this.$refs['map-popup']).openPopup();
        })
        map.flyTo(this.myGeoLocationResult.position, 17, {animate: false})
        this.myGeoLocation = this.myGeoLocationResult.position
        this.confirmConditionLocation = this.myGeoLocationResult.position
      },
      initAddConditionShowForm () {
        if (markerConfirmLocation) {
          markerConfirmLocation.remove()
        }
        this.dialogCondition = true
        this.$refs['condition-form'].active = this.dialogCondition
      },
      cancelAddCondition () {
        this.dialogCondition = false
        if (markerConfirmLocation) {
          markerConfirmLocation.remove()
        }
      },
      getConditionIcon () {
        return L.icon({
            iconUrl: '/static/icon--condition.png',
            iconSize:     [32, 32], // size of the icon
            iconAnchor:   [16, 32], // point of the icon which will correspond to marker's location
            popupAnchor:  [0, -24] // point from which the popup should open relative to the iconAnchor
        })
      },
      async fetchUserConditionsAdded () {
        this.recordingStatus = 'pending'
        let conditions = await this.$httpApi.get('/conditions')
        let photos = await this.$httpApi.get('/photos')
        conditions.data.forEach(condition => {
          condition.photos = photos.data.filter(x => x.condition_id === condition.id)
          this.conditionSaved(condition)
        })
        this.conditionsRecorded = conditions.data.length
      },      
    },
    mounted () {
      this.initMap()
      // this.initStopWatch()
      this.initGeolocation()
      this.fetchUserConditionsAdded()
      // setTimeout(() => console.log("@@", this.$httpApi.defaults.activeApiCalls), 10)
      // setTimeout(() => console.log("@@", this.$httpApi.defaults.activeApiCalls), 1000)
      // setTimeout(() => console.log("@@", this.$httpApi.defaults.activeApiCalls), 2000)
      // console.log(this.$vuetify.theme.secondary)
    },
  }
</script>

<style>
@import url('https://unpkg.com/leaflet@1.5.1/dist/leaflet.css');

html, body {
  overflow: hidden;
}

#audit-controls {
  background-color: #A7DED5;
  border-bottom:solid 1px #aaa;
  /* height: 50px; */
}

#audit-conditions {
  background-color: #fff;
  position: absolute;
  top: 0;
  bottom: 104px;
  left:0;
  right: 0;  
  z-index:9999;
  overflow: auto;
}

#audit-map {
  background-color: #F2EFE9;
  position: absolute;
  top: 0;
  bottom: 104px;
  left:0;
  right: 0;
  /* height: 100%; */
  /* height: calc(100% - 50px); */
}
.fade20 { opacity: 0.2; }
.fade40 { opacity: 0.4; }
.fade60 { opacity: 0.6; }
.fade80 { opacity: 0.8; }
</style>
<style scoped>
/* html, body {
  overflow: hidden;
} */
</style>
